var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"freeMaterial"},[_c('div',{staticClass:"freeMaterial-body"},[_c('div',{staticClass:"search"},[_vm._v("\n            素材作者 : "+_vm._s(_vm.searchParams.author)+"\n            ")]),_c('free-material-list',{attrs:{"tab":_vm.searchParams,"author":"","materialType":"1"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }